import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UserProfile {
  name: string;
  email: string;
  id: string;
  freshworksGuestId: string;
  mobile: string;
  photo?: string;
  setUserProfile: (
    name: string,
    email: string,
    id: string,
    freshworksGuestId: string,
    mobile: string,
    photo?: string
  ) => void;
  setMobile: (mobile: string) => void;
  clearUserProfile: () => void;
}

export const useUserStore = create<UserProfile>()(
  persist(
    set => ({
      name: 'User Name',
      email: 'user@example.com',
      id: '',
      freshworksGuestId: '',
      mobile: '',
      photo: undefined,
      setUserProfile: (name, email, id, freshworksGuestId, mobile, photo) => {
        if (typeof window !== 'undefined') {
          console.log('[USER STORE] setUserProfile called with:', {
            name,
            email,
            id,
            freshworksGuestId,
            mobile,
            nameType: typeof name,
            emailType: typeof email,
          });
        }

        const newState = { name, email, id, freshworksGuestId, mobile, photo };
        if (typeof window !== 'undefined') {
          console.log('[USER STORE] Setting new state:', newState);
        }
        set(newState);

        // Verify it was set (client-side only)
        if (typeof window !== 'undefined') {
          setTimeout(() => {
            const stored = JSON.parse(
              localStorage.getItem('user-profile-storage') || '{}'
            );
            console.log('[USER STORE] State after setUserProfile:', {
              stored,
              state: stored.state,
              matches:
                stored.state?.name === name && stored.state?.email === email,
            });
          }, 50);
        }
      },
      setMobile: (mobile: string) => {
        set({ mobile });
      },
      clearUserProfile: () => {
        if (typeof window !== 'undefined') {
          console.log('[USER STORE] clearUserProfile called');
        }
        const clearedState = {
          name: 'User Name',
          email: 'user@example.com',
          id: '',
          freshworksGuestId: '',
          mobile: '',
          photo: undefined,
        };
        set(clearedState);
        if (typeof window !== 'undefined') {
          console.log('[USER STORE] User profile cleared');
        }
      },
    }),
    {
      name: 'user-profile-storage',
      onRehydrateStorage: () => {
        if (typeof window !== 'undefined') {
          console.log('[USER STORE] Starting rehydration from storage');
        }
        return (state, error) => {
          if (typeof window === 'undefined') return;
          if (error) {
            console.error('[USER STORE] Rehydration error:', error);
          } else {
            console.log('[USER STORE] Rehydration complete:', {
              state,
              name: state?.name,
              email: state?.email,
            });
          }
        };
      },
    }
  )
);
